module.exports = "/_next/static/images/Processing@2x-e6b6a7217472d7a083a912e129683744.webp";